import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { isNumber } from '@/utils/is';
import { dmDidoApi, getDidoApi, updateDidoApi, writeDidoApi } from '@/api';

import { mapState } from 'vuex';
import dayjs from 'dayjs';
import { DateTime } from 'luxon';
import clonedeep from 'lodash.clonedeep';
// import utc from 'dayjs/plugin/utc'
// import timezone from 'dayjs/plugin/timezone'

// dayjs.extend(utc)
// dayjs.extend(timezone)

export default {
  name: 'DidoSettings',
  data: function data() {
    return {
      isEditing: false,
      isLoadingUpdate: false,
      hasCreatedData: true,
      noDataText: '',
      newDeviceId: '',
      editDeviceId: '',
      modalTitle: '',
      mappingIdx: 0,
      // open modal 的 mappingIdx
      pinIdx: 0,
      // open modal 的 pinIdx
      usageOptions: [{
        text: '關',
        value: '關閉警報'
      }, {
        text: '開',
        value: '開啟警報'
      }],
      abnormalDefOptions: [{
        text: 0,
        value: 0
      }, {
        text: 1,
        value: 1
      }],
      panel: [0],
      apiData: {},
      // statusData: [],
      mappingData: [],
      collapseOpenRecord: [],
      // collapse 開關
      loadingDMRecord: '' // DM loading 開關
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState(['dataAdmin', 'userDetail', 'hasRoleAdmin'])), mapState('siteInfoDetail', ['didoStatus'])), {}, {
    urlSiteName: function urlSiteName() {
      return this.$route.query.siteName;
    },
    sortTypeList: function sortTypeList() {
      return this.types.map(function (item) {
        return item.value;
      });
    },
    triggerOptions: function triggerOptions() {
      // mapping 內所有 device 的 DO，value 帶 deviceName 供跨設備觸發辨識 (device::pinName)
      var options = [];
      var _iterator = _createForOfIteratorHelper(this.mappingData || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var device = _step.value;
          var _iterator2 = _createForOfIteratorHelper(device.pinList),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var pin = _step2.value;
              if (pin.pinName.split('_')[0] !== 'DO') continue;
              var text = pin.pinName + '（' + device.deviceName + '）';
              var value = device.deviceName + '::' + pin.pinName;
              options.push({
                text: text,
                value: value
              });
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return options;
    }
  }),
  methods: {
    dayjs: dayjs,
    formatInput: function formatInput(field, mIdx, pIdx, tIdx) {
      var v = this.mappingData[mIdx].pinList[pIdx].triggerDO[tIdx][field];
      if (field === 'postExecuteSecond') {
        this.mappingData[mIdx].pinList[pIdx].triggerDO[tIdx][field] = v < 0 ? 0 : v > 300 ? 300 : v;
      } else {
        this.mappingData[mIdx].pinList[pIdx].triggerDO[tIdx][field] = v < 1 ? 1 : v > 999999 ? 999999 : v;
      }
      this.renewUpdateTime(mIdx, pIdx);
    },
    changeUsage: function changeUsage(value, mIdx, pIdx) {
      // 預設 0
      this.mappingData[mIdx].pinList[pIdx].abnormalDef = 0;
      this.renewUpdateTime(mIdx, pIdx);
    },
    renewUpdateTime: function renewUpdateTime(mIdx, pIdx) {
      this.mappingData[mIdx].pinList[pIdx].updateTime = DateTime.now().toISO();
    },
    handleOpenModal: function handleOpenModal(mIdx, pIdx) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.mappingData[mIdx].pinList[pIdx].triggerDO.length === 0)) {
                  _context.next = 4;
                  break;
                }
                _this.handleAddTriggerDO(mIdx, pIdx);
                _context.next = 6;
                break;
              case 4:
                _context.next = 6;
                return _this.updateExecutionCount(mIdx, pIdx);
              case 6:
                _this.$modal.show('draggableModal');
                _this.mappingIdx = mIdx;
                _this.pinIdx = pIdx;
                _this.modalTitle = "".concat(_this.mappingData[mIdx].deviceName, " - ").concat(_this.mappingData[mIdx].pinList[pIdx].pinName);
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleAddTriggerDO: function handleAddTriggerDO(mIdx, pIdx) {
      this.mappingData[mIdx].pinList[pIdx].triggerDO.push({
        DO_ID: null,
        targetDevice: null,
        matchCurrentValue: null,
        postExecuteSecond: null,
        executionCount: null,
        value: null
        // DO_ID: this.triggerOptions?.[0]?.value,
        // matchCurrentValue: 0,
        // postExecuteSecond: 0,
        // executionCount: 0,
        // value: 1
      });
    },
    handleRemoveTriggerDO: function handleRemoveTriggerDO(mIdx, pIdx, idx) {
      this.mappingData[mIdx].pinList[pIdx].triggerDO.splice(idx, 1);
    },
    triggerDeviceKey: function triggerDeviceKey(trigger, mIdx) {
      // 顯示用 key；targetDevice 未設時預設為腳位自身所屬設備 (與後端消費端 fallback 邏輯一致)
      if (!trigger.DO_ID) return null;
      var deviceName = trigger.targetDevice || this.mappingData[mIdx].deviceName;
      return "".concat(deviceName, "::").concat(trigger.DO_ID);
    },
    handleTriggerDOSelect: function handleTriggerDOSelect(val, trigger, mIdx, pIdx) {
      var _split = (val || '').split('::'),
        _split2 = _slicedToArray(_split, 2),
        deviceName = _split2[0],
        pinName = _split2[1];
      trigger.DO_ID = pinName || null;
      trigger.targetDevice = deviceName || null;
      this.handleTriggerChange(trigger, mIdx, pIdx);
    },
    isTriggerSelf: function isTriggerSelf(trigger, mIdx, pIdx) {
      // 正在選擇的 腳位+設備 = open modal 的 腳位 自身；targetDevice 未設視為同設備 (向下相容)
      var deviceName = trigger.targetDevice || this.mappingData[mIdx].deviceName;
      return trigger.DO_ID === this.mappingData[mIdx].pinList[pIdx].pinName && deviceName === this.mappingData[mIdx].deviceName;
    },
    handleTriggerChange: function handleTriggerChange(trigger, mIdx, pIdx) {
      // 自己修改自己 0 1 互斥
      if (this.isTriggerSelf(trigger, mIdx, pIdx)) {
        if (trigger.matchCurrentValue === 0) {
          trigger.value = 1; // trigger 是響應物件內的 可以直接修改同步更新 data
        } else {
          trigger.value = 0;
        }
      }
      this.renewUpdateTime(mIdx, pIdx);
    },
    handleClearAllTriggerDO: function handleClearAllTriggerDO(mIdx, pIdx) {
      this.mappingData[mIdx].pinList[pIdx].triggerDO = [];
    },
    beforeCloseModal: function beforeCloseModal(event, mIdx, pIdx) {
      var list = this.mappingData[mIdx].pinList[pIdx].triggerDO;

      // 全都空的 clear all 後關閉
      var allEmpty = list.every(function (item) {
        return !isNumber(item.postExecuteSecond) && !isNumber(item.executionCount) && !item.DO_ID && !isNumber(item.matchCurrentValue) && !isNumber(item.value);
      });
      if (allEmpty) {
        list.splice(0);
        return; // 關閉 modal
      }

      // 過濾有值的
      var filteredHasValueList = list.filter(function (item) {
        return isNumber(item.postExecuteSecond) || isNumber(item.executionCount) || item.DO_ID || isNumber(item.matchCurrentValue) || isNumber(item.value);
      });

      // 有值但有空的
      var hasSomeEmpty = filteredHasValueList.some(function (item) {
        return !isNumber(item.postExecuteSecond) || !isNumber(item.executionCount) || !item.DO_ID || !isNumber(item.matchCurrentValue) || !isNumber(item.value);
      });
      if (hasSomeEmpty) {
        event.cancel();
        return this.$swal.fire('請輸入或刪除欄位');
      }

      // 經以上檢查後, 留全都有值的
      this.mappingData[mIdx].pinList[pIdx].triggerDO = filteredHasValueList;
    },
    pinCurrentValueFromWS: function pinCurrentValueFromWS(mIdx, pIdx) {
      var _this$didoStatus,
        _this2 = this,
        _this$mappingData,
        _this$mappingData$mId,
        _this$mappingData$mId2,
        _this$mappingData$mId3,
        _this$didoStatus$find,
        _this$didoStatus2,
        _this$didoStatus2$fin,
        _this$mappingData2,
        _this$mappingData2$mI,
        _this$mappingData2$mI2,
        _this$mappingData2$mI3,
        _this$mappingData3,
        _this$mappingData3$mI,
        _this$mappingData3$mI2,
        _this$mappingData3$mI3,
        _this$mappingData3$mI4,
        _this$mappingData4,
        _this$mappingData4$mI,
        _this$mappingData4$mI2,
        _this$mappingData4$mI3,
        _this$mappingData4$mI4;
      // websocket 傳來的 didoStatus 找 狀態
      var findStatusIdx = (_this$didoStatus = this.didoStatus) === null || _this$didoStatus === void 0 ? void 0 : _this$didoStatus.findIndex(function (x) {
        var _this2$mappingData, _this2$mappingData$mI;
        return x.name === ((_this2$mappingData = _this2.mappingData) === null || _this2$mappingData === void 0 ? void 0 : (_this2$mappingData$mI = _this2$mappingData[mIdx]) === null || _this2$mappingData$mI === void 0 ? void 0 : _this2$mappingData$mI.deviceName);
      });
      var pinName = (_this$mappingData = this.mappingData) === null || _this$mappingData === void 0 ? void 0 : (_this$mappingData$mId = _this$mappingData[mIdx]) === null || _this$mappingData$mId === void 0 ? void 0 : (_this$mappingData$mId2 = _this$mappingData$mId.pinList) === null || _this$mappingData$mId2 === void 0 ? void 0 : (_this$mappingData$mId3 = _this$mappingData$mId2[pIdx]) === null || _this$mappingData$mId3 === void 0 ? void 0 : _this$mappingData$mId3.pinName;

      // 若有 didoStatus 取得值 否則取 mappingData 的值 (兩者皆為 true/false)
      var value = ((_this$didoStatus$find = (_this$didoStatus2 = this.didoStatus) === null || _this$didoStatus2 === void 0 ? void 0 : (_this$didoStatus2$fin = _this$didoStatus2[findStatusIdx]) === null || _this$didoStatus2$fin === void 0 ? void 0 : _this$didoStatus2$fin[pinName]) !== null && _this$didoStatus$find !== void 0 ? _this$didoStatus$find : (_this$mappingData2 = this.mappingData) === null || _this$mappingData2 === void 0 ? void 0 : (_this$mappingData2$mI = _this$mappingData2[mIdx]) === null || _this$mappingData2$mI === void 0 ? void 0 : (_this$mappingData2$mI2 = _this$mappingData2$mI.pinList) === null || _this$mappingData2$mI2 === void 0 ? void 0 : (_this$mappingData2$mI3 = _this$mappingData2$mI2[pIdx]) === null || _this$mappingData2$mI3 === void 0 ? void 0 : _this$mappingData2$mI3.currentValue) ? 1 : 0;
      var label = value === 1 ? (_this$mappingData3 = this.mappingData) === null || _this$mappingData3 === void 0 ? void 0 : (_this$mappingData3$mI = _this$mappingData3[mIdx]) === null || _this$mappingData3$mI === void 0 ? void 0 : (_this$mappingData3$mI2 = _this$mappingData3$mI.pinList) === null || _this$mappingData3$mI2 === void 0 ? void 0 : (_this$mappingData3$mI3 = _this$mappingData3$mI2[pIdx]) === null || _this$mappingData3$mI3 === void 0 ? void 0 : (_this$mappingData3$mI4 = _this$mappingData3$mI3.zeroOneDef) === null || _this$mappingData3$mI4 === void 0 ? void 0 : _this$mappingData3$mI4.one : (_this$mappingData4 = this.mappingData) === null || _this$mappingData4 === void 0 ? void 0 : (_this$mappingData4$mI = _this$mappingData4[mIdx]) === null || _this$mappingData4$mI === void 0 ? void 0 : (_this$mappingData4$mI2 = _this$mappingData4$mI.pinList) === null || _this$mappingData4$mI2 === void 0 ? void 0 : (_this$mappingData4$mI3 = _this$mappingData4$mI2[pIdx]) === null || _this$mappingData4$mI3 === void 0 ? void 0 : (_this$mappingData4$mI4 = _this$mappingData4$mI3.zeroOneDef) === null || _this$mappingData4$mI4 === void 0 ? void 0 : _this$mappingData4$mI4.zero;
      return {
        value: value,
        label: label
      };
    },
    stateCurrentValueFromWS: function stateCurrentValueFromWS(mIdx) {
      var _this$didoStatus3,
        _this3 = this,
        _this$didoStatus4,
        _this$didoStatus4$fin;
      // websocket 傳來的 didoStatus 找 連現狀態
      var findStatusIdx = (_this$didoStatus3 = this.didoStatus) === null || _this$didoStatus3 === void 0 ? void 0 : _this$didoStatus3.findIndex(function (x) {
        var _this3$mappingData, _this3$mappingData$mI;
        return x.name === ((_this3$mappingData = _this3.mappingData) === null || _this3$mappingData === void 0 ? void 0 : (_this3$mappingData$mI = _this3$mappingData[mIdx]) === null || _this3$mappingData$mI === void 0 ? void 0 : _this3$mappingData$mI.deviceName);
      });
      var value = (_this$didoStatus4 = this.didoStatus) === null || _this$didoStatus4 === void 0 ? void 0 : (_this$didoStatus4$fin = _this$didoStatus4[findStatusIdx]) === null || _this$didoStatus4$fin === void 0 ? void 0 : _this$didoStatus4$fin.state;
      return value;
    },
    addDido: function addDido() {
      this.mappingData.push({
        deviceName: '',
        pinList: []
      });
      this.collapseOpenRecord.push(true);
    },
    updateExecutionCount: function updateExecutionCount(mIdx, pIdx) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, _res$data$data, _res$data$data$mappin, _res$data$data$mappin2, _res$data$data$mappin3, _res$data$data$mappin4, _res$data$data$mappin5, _res$data$data2, _res$data$data2$mappi, _res$data$data2$mappi2, _res$data$data2$mappi3, _res$data$data2$mappi4, triggerDO;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return getDidoApi(_this4.urlSiteName);
              case 3:
                res = _context2.sent;
                if (res.data.msg === 'Data fetched successfully') {
                  if ((_res$data$data = res.data.data) !== null && _res$data$data !== void 0 && (_res$data$data$mappin = _res$data$data.mapping) !== null && _res$data$data$mappin !== void 0 && (_res$data$data$mappin2 = _res$data$data$mappin[mIdx]) !== null && _res$data$data$mappin2 !== void 0 && (_res$data$data$mappin3 = _res$data$data$mappin2.pinList) !== null && _res$data$data$mappin3 !== void 0 && (_res$data$data$mappin4 = _res$data$data$mappin3[pIdx]) !== null && _res$data$data$mappin4 !== void 0 && (_res$data$data$mappin5 = _res$data$data$mappin4.triggerDO) !== null && _res$data$data$mappin5 !== void 0 && _res$data$data$mappin5.length) {
                    triggerDO = (_res$data$data2 = res.data.data) === null || _res$data$data2 === void 0 ? void 0 : (_res$data$data2$mappi = _res$data$data2.mapping) === null || _res$data$data2$mappi === void 0 ? void 0 : (_res$data$data2$mappi2 = _res$data$data2$mappi[mIdx]) === null || _res$data$data2$mappi2 === void 0 ? void 0 : (_res$data$data2$mappi3 = _res$data$data2$mappi2.pinList) === null || _res$data$data2$mappi3 === void 0 ? void 0 : (_res$data$data2$mappi4 = _res$data$data2$mappi3[pIdx]) === null || _res$data$data2$mappi4 === void 0 ? void 0 : _res$data$data2$mappi4.triggerDO;
                    triggerDO.forEach(function (item, idx) {
                      // eslint-disable-next-line standard/computed-property-even-spacing
                      _this4.mappingData[mIdx].pinList[pIdx].triggerDO[idx].executionCount = item.executionCount;
                    });
                  }
                }
                _context2.next = 10;
                break;
              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                console.log('updateExecutionCount getDido error', _context2.t0);
              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }))();
    },
    getDido: function getDido() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, _res$data$data3, _res$data$data4;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return getDidoApi(_this5.urlSiteName);
              case 3:
                res = _context3.sent;
                if (!(res.data.msg === 'No data found')) {
                  _context3.next = 8;
                  break;
                }
                _this5.noDataText = '尚未建立資料，請新增 Device ID';
                _this5.hasCreatedData = false;
                return _context3.abrupt("return");
              case 8:
                if (!(res.data.msg === 'No status found')) {
                  _context3.next = 11;
                  break;
                }
                _this5.noDataText = '已建立 Device ID，尚無上傳資料';
                return _context3.abrupt("return");
              case 11:
                if (res.data.msg === 'Data fetched successfully') {
                  _this5.apiData = clonedeep(res.data.data);
                  _this5.mappingData = clonedeep((_res$data$data3 = res.data.data) === null || _res$data$data3 === void 0 ? void 0 : _res$data$data3.mapping);
                  _this5.collapseOpenRecord = (_res$data$data4 = res.data.data) === null || _res$data$data4 === void 0 ? void 0 : _res$data$data4.mapping.map(function (_) {
                    return true;
                  });
                }
                _context3.next = 17;
                break;
              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3["catch"](0);
                console.log('getDido error', _context3.t0);
              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 14]]);
      }))();
    },
    writeDido: function writeDido() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var data, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this6.newDeviceId) {
                  _context4.next = 2;
                  break;
                }
                return _context4.abrupt("return", _this6.$swal.fire('請輸入 Device ID'));
              case 2:
                data = {
                  factoryName: _this6.urlSiteName,
                  deviceId: _this6.newDeviceId,
                  mapping: [
                    // {
                    //   deviceName: '',
                    //   pinList: [
                    //     {
                    //       pinName: '',
                    //       abnormalID: '',
                    //       usage: '',
                    //       zeroOneDef: {
                    //         zero: '',
                    //         one: ''
                    //       },
                    //       desc: '',
                    //       currentValue: 0,
                    //       status: '',
                    //       triggerDO: [],
                    //       execute: 0,
                    //       enabled: true,
                    //       updateTime: dayjs().tz('Asia/Taipei').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                    //       abnormalDef: 0
                    //     }
                    //   ]
                    // }
                  ]
                };
                _context4.prev = 3;
                _context4.next = 6;
                return writeDidoApi(data);
              case 6:
                res = _context4.sent;
                if (res.data.msg === 'Data written successfully') {
                  _this6.$swal.fire({
                    icon: 'success',
                    title: '新增成功'
                  });
                  _this6.hasCreatedData = true;
                  _this6.noDataText = '';
                  _this6.getDido();
                }
                _context4.next = 13;
                break;
              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](3);
                console.log('writeDido error', _context4.t0);
              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[3, 10]]);
      }))();
    },
    updateDido: function updateDido() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var params, res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // 先關閉設定視窗
                // this.handleOpenModal(this.mappingIdx, this.pinIdx)

                _this7.isLoadingUpdate = true;
                params = {
                  id: _this7.apiData.id,
                  factoryName: _this7.apiData.factoryName,
                  deviceId: _this7.editDeviceId || _this7.apiData.deviceId,
                  mapping: _this7.mappingData.map(function (item) {
                    return {
                      deviceName: item.deviceName,
                      pinList: item.pinList.map(function (pin) {
                        return _objectSpread(_objectSpread({}, pin), {}, {
                          currentValue: pin.currentValue ? 1 : 0 // true false 轉 1 0
                        });
                      })
                    };
                  })
                };
                _context5.prev = 2;
                _context5.next = 5;
                return updateDidoApi(params);
              case 5:
                res = _context5.sent;
                if (res.data.msg === 'Data updated successfully') {
                  _this7.$swal.fire({
                    icon: 'success',
                    title: '儲存成功'
                  });
                  _this7.getDido();
                }
                _context5.next = 13;
                break;
              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](2);
                console.log('updateDido error', _context5.t0);
                _this7.$swal.fire({
                  icon: 'error',
                  title: '儲存失敗'
                });
              case 13:
                _context5.prev = 13;
                _this7.isLoadingUpdate = false;
                _this7.isEditing = false;
                return _context5.finish(13);
              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[2, 9, 13, 17]]);
      }))();
    },
    // async deleteDido () {
    //   const params = {
    //     factoryName: this.apiData.factoryName,
    //     id: this.apiData.id
    //   }
    //   try {
    //     const res = await deleteDidoApi(params)
    //     console.log(res)
    //   } catch (error) {
    //     console.log('deleteDido error', error)
    //   }
    // },
    dmDido: function dmDido(deviceName, pinName, execute) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var params, res;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!_this8.loadingDMRecord) {
                  _context6.next = 2;
                  break;
                }
                return _context6.abrupt("return");
              case 2:
                _this8.loadingDMRecord = "".concat(deviceName, "_").concat(pinName);
                params = {
                  operation: 'write',
                  deviceId: _this8.apiData.deviceId,
                  srcName: deviceName,
                  tag: pinName,
                  dataValue: execute
                };
                _context6.prev = 4;
                _context6.next = 7;
                return dmDidoApi(params);
              case 7:
                res = _context6.sent;
                if (res.data.success) {
                  _this8.$swal.fire({
                    icon: 'success',
                    title: '傳送成功',
                    text: "\u50B3\u9001 ".concat(execute, " \u5230 ").concat(deviceName, " ").concat(pinName)
                  });
                }
                _context6.next = 15;
                break;
              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](4);
                console.log('dmDido error', _context6.t0);
                _this8.$swal.fire({
                  icon: 'error',
                  title: '傳送失敗',
                  text: "\u50B3\u9001 ".concat(execute, " \u5230 ").concat(deviceName, " ").concat(pinName)
                });
              case 15:
                _context6.prev = 15;
                _this8.loadingDMRecord = '';
                return _context6.finish(15);
              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[4, 11, 15, 18]]);
      }))();
    } // showMessage ({
    //   icon = '',
    //   title = '',
    //   text = '',
    //   showConfirmButton = false
    // }) {
    //   this.$swal.fire({ icon, title, text, showConfirmButton })
    // }
  },
  created: function created() {
    var _this9 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _this9.getDido();
            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  }
};